const countries = [
  'Afghanistan',
  'Albania',
  'Algeria',
  'Andorra',
  'Angola',
  'Antigua and Barbuda',
  'Argentina',
  'Armenia',
  'Australia',
  'Austria',
  'Azerbaijan',
  'Bahamas',
  'Bahrain',
  'Bangladesh',
  'Barbados',
  'Belarus',
  'Belgium',
  'Belize',
  'Benin',
  'Bhutan',
  'Bolivia',
  'Bosnia and Herzegovina',
  'Botswana',
  'Brazil',
  'Brunei',
  'Bulgaria',
  'Burkina Faso',
  'Burundi',
  'Côte dIvoire',
  'Cabo Verde',
  'Cambodia',
  'Cameroon',
  'Canada',
  'Central African Republic',
  'Chad',
  'Chile',
  'China',
  'Colombia',
  'Comoros',
  'Congo (Congo-Brazzaville)',
  'Costa Rica',
  'Croatia',
  'Cuba',
  'Cyprus',
  'Czechia (Czech Republic)',
  'Democratic Republic of the Congo',
  'Denmark',
  'Djibouti',
  'Dominica',
  'Dominican Republic',
  'Ecuador',
  'Egypt',
  'El Salvador',
  'Equatorial Guinea',
  'Eritrea',
  'Estonia',
  'Eswatini (fmr. "Swaziland")',
  'Ethiopia',
  'Fiji',
  'Finland',
  'France',
  'Gabon',
  'Gambia',
  'Georgia',
  'Germany',
  'Ghana',
  'Greece',
  'Grenada',
  'Guatemala',
  'Guinea',
  'Guinea-Bissau',
  'Guyana',
  'Haiti',
  'Holy See',
  'Honduras',
  'Hungary',
  'Iceland',
  'India',
  'Indonesia',
  'Iran',
  'Iraq',
  'Ireland',
  'Israel',
  'Italy',
  'Jamaica',
  'Japan',
  'Jordan',
  'Kazakhstan',
  'Kenya',
  'Kiribati',
  'Kuwait',
  'Kyrgyzstan',
  'Laos',
  'Latvia',
  'Lebanon',
  'Lesotho',
  'Liberia',
  'Libya',
  'Liechtenstein',
  'Lithuania',
  'Luxembourg',
  'Madagascar',
  'Malawi',
  'Malaysia',
  'Maldives',
  'Mali',
  'Malta',
  'Marshall Islands',
  'Mauritania',
  'Mauritius',
  'Mexico',
  'Micronesia',
  'Moldova',
  'Monaco',
  'Mongolia',
  'Montenegro',
  'Morocco',
  'Mozambique',
  'Myanmar (formerly Burma)',
  'Namibia',
  'Nauru',
  'Nepal',
  'Netherlands',
  'New Zealand',
  'Nicaragua',
  'Niger',
  'Nigeria',
  'North Korea',
  'North Macedonia',
  'Norway',
  'Oman',
  'Pakistan',
  'Palau',
  'Palestine State',
  'Panama',
  'Papua New Guinea',
  'Paraguay',
  'Peru',
  'Philippines',
  'Poland',
  'Portugal',
  'Qatar',
  'Romania',
  'Russia',
  'Rwanda',
  'Saint Kitts and Nevis',
  'Saint Lucia',
  'Saint Vincent and the Grenadines',
  'Samoa',
  'San Marino',
  'Sao Tome and Principe',
  'Saudi Arabia',
  'Senegal',
  'Serbia',
  'Seychelles',
  'Sierra Leone',
  'Singapore',
  'Slovakia',
  'Slovenia',
  'Solomon Islands',
  'Somalia',
  'South Africa',
  'South Korea',
  'South Sudan',
  'Spain',
  'Sri Lanka',
  'Sudan',
  'Suriname',
  'Sweden',
  'Switzerland',
  'Syria',
  'Tajikistan',
  'Tanzania',
  'Thailand',
  'Timor-Leste',
  'Togo',
  'Tonga',
  'Trinidad and Tobago',
  'Tunisia',
  'Turkey',
  'Turkmenistan',
  'Tuvalu',
  'Uganda',
  'Ukraine',
  'United Arab Emirates',
  'United Kingdom',
  'United States of America',
  'Uruguay',
  'Uzbekistan',
  'Vanuatu',
  'Venezuela',
  'Vietnam',
  'Yemen',
  'Zambia',
  'Zimbabwe',
];

const initialState = {

  isLoading : true,

  vendorFormFields: [
    {
      type: 'text',
      label: 'First Name',
      defaultValue: null,
      style: { width: '45%' },
    },
    {
      style: { width: '45%' },
      type: 'text',
      label: 'Last Name',
      defaultValue: null,
    },
    {
      style: { width: '93%' },
      type: 'email',
      label: 'Email',
      defaultValue: null,
    },
    {
      style: { width: '23%' },
      type: 'dropdown',
      label: 'Country',
      dropdownList: [...countries],
    },
    {
      style: { width: '23%' },
      type: 'number',
      label: 'Country Code',
      defaultValue: null,
    },
    {
      style: { width: '39%' },
      type: 'number',
      label: 'Phone Number',
      defaultValue: null,
    },
    {
      style: { width: '93%' },
      type: 'text',
      label: 'Address',
      defaultValue: null,
    },
    {
      style: { width: '93%' },
      type: 'text',
      label: 'City',
      defaultValue: null,
    },
    {
      style: { width: '93%' },
      type: 'number',
      label: 'Pin',
      defaultValue: null,
    },
  ],
  vendorTableData: [
    { id: 1, name: 'James', mobile: 236479515, address: 'Johannesburg', is_active : 1 , is_requested : 1 },
    { id: 2, name: 'Norman', mobile: 789452256, address: 'Cape Town',  is_active : 1 , is_requested : 1 },
    { id: 3, name: 'Gugulethu', mobile: 6546512111, address: 'East London', is_active : 0 , is_requested : 1 },
    { id: 4, name: 'Bongani', mobile: 5454151255, address: 'Pretoria', is_active : 0 , is_requested : 1 },
    { id: 5, name: 'Rajat', mobile: 7379514571, address: 'Durban', is_active : 0 , is_requested : 0 },
    { id: 6, name: 'Lesego', mobile: 7379514571, address: 'Polokwane', is_active : 0 , is_requested : 0 },
  ],
};

const vendorReducer = (state = initialState, action) => {
  switch (action.type) {

    case "vendor_list_success" : 
      /* Dashboard Reducers Logic */
      return {
          ...state,
          isLoading : false,
          state : state
      } ;

    break ;

    case "vendor_list_failure" :
      
      return {
          ...state,
          isLoading : false,
          state : state
      } ;

    break;

    default:
      return state;
  }
};

export default vendorReducer;
